module.exports = __webpack_public_path__ + "static/media/bardahl.e83f8db1.png";